// extracted by mini-css-extract-plugin
module.exports = {"container":"Savings_container__tfaSw","savingsLine":"Savings_savingsLine__BkLM6","seperation":"Savings_seperation__OK9QD","totals":"Savings_totals__RjFK5"};